/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  TCV_SET_OFERTA_PREAPROBADA,
  TCV_SET_OFERTA_SOLICITUD,
  TCV_SET_OFERTA_AUMENTO,
  TCV_SET_RESULTADO_CONFIRMACION,
  TCV_CLEAR,
} from 'src/actions/tcvActions';

const initialState = {
  ofertaPreaprobada: null, // oferta TC/TARJETA/PREAPROBADO normalizada desde Listar
  ofertaSolicitud: null, // oferta TC/TARJETA/SOLICITADO normalizada desde Listar
  ofertaAumento: null, // oferta TC/AUMENTO normalizada desde Listar
  resultadoConfirmacion: null, // data del Confirmar pre-aprobada (tarjeta generada)
};

const tcvReducer = (state = initialState, action) => {
  switch (action.type) {
    case TCV_SET_OFERTA_PREAPROBADA: {
      const { oferta } = action.payload;
      return produce(state, (draft) => {
        draft.ofertaPreaprobada = oferta;
      });
    }

    case TCV_SET_OFERTA_SOLICITUD: {
      const { oferta } = action.payload;
      return produce(state, (draft) => {
        draft.ofertaSolicitud = oferta;
      });
    }

    case TCV_SET_OFERTA_AUMENTO: {
      const { oferta } = action.payload;
      return produce(state, (draft) => {
        draft.ofertaAumento = oferta;
      });
    }

    case TCV_SET_RESULTADO_CONFIRMACION: {
      const { resultado } = action.payload;
      return produce(state, (draft) => {
        draft.resultadoConfirmacion = resultado;
      });
    }

    case TCV_CLEAR: {
      return produce(state, (draft) => {
        draft.ofertaPreaprobada = null;
        draft.ofertaSolicitud = null;
        draft.ofertaAumento = null;
        draft.resultadoConfirmacion = null;
      });
    }

    default: {
      return state;
    }
  }
};

export default tcvReducer;
